import request from '@/libs/request'

// 幼儿园列表
export function schoolList (data) {
  return request({
    url: `school/list`,
    method: 'get',
    params: data
  })
}
// 幼儿园 删除
export function schoolDelete (data) {
  return request({
    url: `school/delete`,
    method: 'get',
    params: data
  })
}

// 班级列表
export function classList (data) {
  return request({
    url: `schoolClass/list`,
    method: 'get',
    params: data
  })
}
// 班级删除
export function classDelete (data) {
  return request({
    url: `schoolClass/delete`,
    method: 'get',
    params: data
  })
}

